module.exports = __webpack_public_path__ + "img/5-3.e162a3ab.png";